import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

export const LOYALTY_PALETTES = StyleSheet.create({
  premiumBgColor: {
    backgroundColor: theme.colors.BLACK,
  },
  premiumFgColor: {
    color: theme.colors.WHITE,
  },
});
